module.exports = __webpack_public_path__ + "img/united-arab-emirates.1b9afcb5.svg";